document.addEventListener("DOMContentLoaded", () => {
  const trigger = document.querySelector("[data-component~=bulk-review-modal]");

  if (!trigger) {
    return;
  }

  trigger.addEventListener("click", (event) => {
    event.preventDefault();
    const target = event.currentTarget;
    const vueProps = JSON.parse(target.dataset.vueProps);

    mountBulkReviewRequest(target.closest("form"), vueProps);
  });

  function createBulkReviewRequestContainer() {
    const id = "bulk-review-request-container";
    const selector = `#${id}`;

    const container = document.createElement("div");
    container.id = id;

    document.body.appendChild(container);
    return { id, selector };
  }

  function mountBulkReviewRequest(form, vueProps) {
    const { selector } = createBulkReviewRequestContainer();

    const resources = form.elements.bulk_records.value.split(",").map((resource) => {
      const [type, id] = resource.split("-");
      return { id, type };
    });
    const reviewableId = resources[0].id;

    const pageContext = "bulkReviewRequest";
    const bulkCount = form.elements.bulk_count.value;

    const bulkScope = form.elements.bulk_scope.value;
    const bulkRecords = form.elements.bulk_records.value;
    let invitationData = {};
    if (bulkScope.length) {
      invitationData.bulk_scope = bulkScope;
    } else {
      invitationData.bulk_records = bulkRecords;
    }

    const props = {
      pageContext,
      bulkCount,
      reviewableId,
      invitationData,
      onDone: () => onBulkReviewRequestDone(),
      ...vueProps,
    };
    const detail = { selector, props };
    const event = new CustomEvent("review-pane:mount", { detail });

    document.dispatchEvent(event);
  }

  function onBulkReviewRequestDone() {
    console.log("onBulkReviewRequestDone");
  }
});
